export default "__VITE_ASSET__BnS7N30f__"